import agentAddressDictionary from '@entities/agent-address/i18n/ru/agent-address.dic.json';

export const agentAddress = {
  AGENT_ADDRESS: agentAddressDictionary,
};

export const agentAddressNamespaces = ['AGENT_ADDRESS'];
